export const VIDEO_ORIENTATION = {
  PORTRAIT: {
    name: 'Portrait',
    width: 38,
    height: 49,
    aspectRatio: 9 / 16,
    variant: 'portrait',
    videoWidth: 720,
    videoHeight: 1280,
  },
  SQUARE: {
    name: 'Square',
    width: 40,
    height: 40,
    aspectRatio: 1,
    variant: 'square',
    videoWidth: 720,
    videoHeight: 720,
  },
  LANDSCAPE: {
    name: 'Landscape',
    width: 50,
    height: 28,
    aspectRatio: 16 / 9,
    variant: 'landscape',
    videoWidth: 1280,
    videoHeight: 720,
  },
};

export const getPreviewResolution = height => height / VIDEO_ORIENTATION.PORTRAIT.videoHeight;